var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-home"},[_c('div',[_c('home-navbar',{attrs:{"get-div":_vm.foucusDiv}}),_c('home-content',{on:{"getFocusDiv":function($event){_vm.foucusDiv=$event}}}),_c('home-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }